module.exports = __webpack_public_path__ + "img/bird-10-right.0d7182bf.png";